"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : IMAGE PREVIEW : STYLES--------------- ++++++++++ */


var _default = {
  imagepreview: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: (0, _index.pxToEm)(16),
    '& .preview': {
      height: (0, _index.pxToEm)(56),
      width: (0, _index.pxToEm)(72),
      borderRadius: (0, _index.pxToEm)(4)
    },
    '& .filename': {
      maxWidth: (0, _index.pxToEm)(213),
      color: 'rgb(20, 148, 244)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& .link': {
      marginTop: (0, _index.pxToEm)(9)
    }
  }
};
exports.default = _default;